@file:OptIn(InternalResourceApi::class)

package evoshift.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/evoshift.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_844_657_945)
public val Res.string.actual_work_action_description: StringResource by lazy {
      StringResource("string:actual_work_action_description", "actual_work_action_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15253, 94),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21373, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11336, 86),
      ))
    }

@delegate:ResourceContentHash(1_320_930_527)
public val Res.string.actual_work_as_planned: StringResource by lazy {
      StringResource("string:actual_work_as_planned", "actual_work_as_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15399, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21559, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11470, 54),
      ))
    }

@delegate:ResourceContentHash(-1_349_106_240)
public val Res.string.actual_work_end: StringResource by lazy {
      StringResource("string:actual_work_end", "actual_work_end", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15462, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21622, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11525, 27),
      ))
    }

@delegate:ResourceContentHash(188_841_047)
public val Res.string.actual_work_no_show: StringResource by lazy {
      StringResource("string:actual_work_no_show", "actual_work_no_show", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15545, 75),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21725, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11604, 63),
      ))
    }

@delegate:ResourceContentHash(652_960_304)
public val Res.string.actual_work_no_show_reason: StringResource by lazy {
      StringResource("string:actual_work_no_show_reason", "actual_work_no_show_reason", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15494, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21662, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11553, 50),
      ))
    }

@delegate:ResourceContentHash(922_285_477)
public val Res.string.actual_work_nobody: StringResource by lazy {
      StringResource("string:actual_work_nobody", "actual_work_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15621, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21829, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11668, 42),
      ))
    }

@delegate:ResourceContentHash(-184_521_284)
public val Res.string.actual_work_person: StringResource by lazy {
      StringResource("string:actual_work_person", "actual_work_person", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15743, 46),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21983, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11770, 42),
      ))
    }

@delegate:ResourceContentHash(-2_114_164_840)
public val Res.string.actual_work_person_missing: StringResource by lazy {
      StringResource("string:actual_work_person_missing", "actual_work_person_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15676, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 21896, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11711, 58),
      ))
    }

@delegate:ResourceContentHash(-235_683_937)
public val Res.string.actual_work_reason: StringResource by lazy {
      StringResource("string:actual_work_reason", "actual_work_reason", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15882, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22162, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11905, 50),
      ))
    }

@delegate:ResourceContentHash(1_310_285_864)
public val Res.string.actual_work_reason_hint: StringResource by lazy {
      StringResource("string:actual_work_reason_hint", "actual_work_reason_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15790, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22042, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11813, 91),
      ))
    }

@delegate:ResourceContentHash(856_975_127)
public val Res.string.actual_work_record_absence: StringResource by lazy {
      StringResource("string:actual_work_record_absence", "actual_work_record_absence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 15937, 90),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22249, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11956, 86),
      ))
    }

@delegate:ResourceContentHash(1_719_576_228)
public val Res.string.actual_work_saved_absence: StringResource by lazy {
      StringResource("string:actual_work_saved_absence", "actual_work_saved_absence", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16028, 121),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22384, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12043, 97),
      ))
    }

@delegate:ResourceContentHash(-1_321_388_948)
public val Res.string.actual_work_saved_nobody: StringResource by lazy {
      StringResource("string:actual_work_saved_nobody", "actual_work_saved_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16150, 120),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22542, 180),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12141, 104),
      ))
    }

@delegate:ResourceContentHash(1_457_938_950)
public val Res.string.actual_work_saved_planned: StringResource by lazy {
      StringResource("string:actual_work_saved_planned", "actual_work_saved_planned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16271, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22723, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12246, 69),
      ))
    }

@delegate:ResourceContentHash(1_306_501_531)
public val Res.string.actual_work_section: StringResource by lazy {
      StringResource("string:actual_work_section", "actual_work_section", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16341, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22809, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12316, 55),
      ))
    }

@delegate:ResourceContentHash(2_047_194_839)
public val Res.string.actual_work_someone_else: StringResource by lazy {
      StringResource("string:actual_work_someone_else", "actual_work_someone_else", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16401, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22893, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12372, 48),
      ))
    }

@delegate:ResourceContentHash(-1_289_022_070)
public val Res.string.actual_work_start: StringResource by lazy {
      StringResource("string:actual_work_start", "actual_work_start", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16450, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 22954, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12421, 33),
      ))
    }

@delegate:ResourceContentHash(124_790_317)
public val Res.string.actual_work_subtitle: StringResource by lazy {
      StringResource("string:actual_work_subtitle", "actual_work_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16562, 60),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23086, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12521, 56),
      ))
    }

@delegate:ResourceContentHash(1_844_322_376)
public val Res.string.actual_work_subtitle_open: StringResource by lazy {
      StringResource("string:actual_work_subtitle_open", "actual_work_subtitle_open", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16488, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23000, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12455, 65),
      ))
    }

@delegate:ResourceContentHash(-846_459_979)
public val Res.string.actual_work_times: StringResource by lazy {
      StringResource("string:actual_work_times", "actual_work_times", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16894, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23510, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12841, 41),
      ))
    }

@delegate:ResourceContentHash(155_539_100)
public val Res.string.actual_work_times_from_clock: StringResource by lazy {
      StringResource("string:actual_work_times_from_clock", "actual_work_times_from_clock", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16623, 100),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23159, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12578, 92),
      ))
    }

@delegate:ResourceContentHash(334_433_368)
public val Res.string.actual_work_times_from_plan: StringResource by lazy {
      StringResource("string:actual_work_times_from_plan", "actual_work_times_from_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16724, 107),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23292, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12671, 111),
      ))
    }

@delegate:ResourceContentHash(1_397_715_740)
public val Res.string.actual_work_times_missing: StringResource by lazy {
      StringResource("string:actual_work_times_missing", "actual_work_times_missing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16832, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23432, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12783, 57),
      ))
    }

@delegate:ResourceContentHash(-867_653_406)
public val Res.string.actual_work_title: StringResource by lazy {
      StringResource("string:actual_work_title", "actual_work_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 16944, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23572, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12883, 53),
      ))
    }

@delegate:ResourceContentHash(-1_347_338_907)
public val Res.string.actual_work_worked_by: StringResource by lazy {
      StringResource("string:actual_work_worked_by", "actual_work_worked_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17006, 73),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23654, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12937, 69),
      ))
    }

@delegate:ResourceContentHash(-180_790_072)
public val Res.string.add: StringResource by lazy {
      StringResource("string:add", "add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18552, 19),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25780, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14387, 15),
      ))
    }

@delegate:ResourceContentHash(1_014_272_059)
public val Res.string.add_shift_add_another: StringResource by lazy {
      StringResource("string:add_shift_add_another", "add_shift_add_another", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17080, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23748, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13007, 61),
      ))
    }

@delegate:ResourceContentHash(-1_682_367_251)
public val Res.string.add_shift_add_selected: StringResource by lazy {
      StringResource("string:add_shift_add_selected", "add_shift_add_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17142, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23842, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13069, 58),
      ))
    }

@delegate:ResourceContentHash(-1_729_130_494)
public val Res.string.add_shift_assign: StringResource by lazy {
      StringResource("string:add_shift_assign", "add_shift_assign", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17205, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 23921, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13128, 60),
      ))
    }

@delegate:ResourceContentHash(-1_175_258_525)
public val Res.string.add_shift_conflict_warning: StringResource by lazy {
      StringResource("string:add_shift_conflict_warning", "add_shift_conflict_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17270, 178),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24030, 258),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13189, 190),
      ))
    }

@delegate:ResourceContentHash(-1_711_702_564)
public val Res.string.add_shift_custom: StringResource by lazy {
      StringResource("string:add_shift_custom", "add_shift_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17449, 44),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24289, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13380, 40),
      ))
    }

@delegate:ResourceContentHash(1_199_765_706)
public val Res.string.add_shift_dialog_title: StringResource by lazy {
      StringResource("string:add_shift_dialog_title", "add_shift_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17494, 54),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24346, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13421, 50),
      ))
    }

@delegate:ResourceContentHash(-576_569_961)
public val Res.string.add_shift_duration: StringResource by lazy {
      StringResource("string:add_shift_duration", "add_shift_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17549, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24413, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13472, 42),
      ))
    }

@delegate:ResourceContentHash(2_129_327_881)
public val Res.string.add_shift_next_day: StringResource by lazy {
      StringResource("string:add_shift_next_day", "add_shift_next_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17600, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24476, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13515, 50),
      ))
    }

@delegate:ResourceContentHash(1_061_951_186)
public val Res.string.add_shift_nobody: StringResource by lazy {
      StringResource("string:add_shift_nobody", "add_shift_nobody", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17667, 84),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24575, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13566, 76),
      ))
    }

@delegate:ResourceContentHash(954_855_121)
public val Res.string.add_shift_nothing: StringResource by lazy {
      StringResource("string:add_shift_nothing", "add_shift_nothing", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17752, 81),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24700, 129),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13643, 85),
      ))
    }

@delegate:ResourceContentHash(-302_157_835)
public val Res.string.add_shift_pick_several: StringResource by lazy {
      StringResource("string:add_shift_pick_several", "add_shift_pick_several", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17834, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24830, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13729, 46),
      ))
    }

@delegate:ResourceContentHash(476_013_895)
public val Res.string.add_shift_pick_time: StringResource by lazy {
      StringResource("string:add_shift_pick_time", "add_shift_pick_time", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17885, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24897, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13776, 43),
      ))
    }

@delegate:ResourceContentHash(-1_275_345_412)
public val Res.string.add_shift_unavailable_warning: StringResource by lazy {
      StringResource("string:add_shift_unavailable_warning", "add_shift_unavailable_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 17937, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 24953, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13820, 89),
      ))
    }

@delegate:ResourceContentHash(-123_590_938)
public val Res.string.add_to_calendar: StringResource by lazy {
      StringResource("string:add_to_calendar", "add_to_calendar", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18500, 51),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25712, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14343, 43),
      ))
    }

@delegate:ResourceContentHash(761_194_408)
public val Res.string.add_to_calendar_download: StringResource by lazy {
      StringResource("string:add_to_calendar_download", "add_to_calendar_download", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18055, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25103, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13910, 52),
      ))
    }

@delegate:ResourceContentHash(-2_134_087_940)
public val Res.string.add_to_calendar_hint: StringResource by lazy {
      StringResource("string:add_to_calendar_hint", "add_to_calendar_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18112, 236),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25172, 328),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13963, 232),
      ))
    }

@delegate:ResourceContentHash(954_924_133)
public val Res.string.add_to_calendar_none: StringResource by lazy {
      StringResource("string:add_to_calendar_none", "add_to_calendar_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18349, 92),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25501, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14196, 84),
      ))
    }

@delegate:ResourceContentHash(-1_557_974_123)
public val Res.string.add_to_calendar_saved: StringResource by lazy {
      StringResource("string:add_to_calendar_saved", "add_to_calendar_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18442, 57),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25642, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14281, 61),
      ))
    }

@delegate:ResourceContentHash(-1_647_431_013)
public val Res.string.adjustment_add: StringResource by lazy {
      StringResource("string:adjustment_add", "adjustment_add", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18572, 62),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25808, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14403, 54),
      ))
    }

@delegate:ResourceContentHash(-1_327_099_947)
public val Res.string.adjustment_amount: StringResource by lazy {
      StringResource("string:adjustment_amount", "adjustment_amount", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18635, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25899, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14458, 45),
      ))
    }

@delegate:ResourceContentHash(1_087_886_853)
public val Res.string.adjustment_day: StringResource by lazy {
      StringResource("string:adjustment_day", "adjustment_day", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18677, 30),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25945, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14504, 26),
      ))
    }

@delegate:ResourceContentHash(1_010_823_866)
public val Res.string.adjustment_delete_confirm: StringResource by lazy {
      StringResource("string:adjustment_delete_confirm", "adjustment_delete_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18708, 117),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 25980, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14531, 97),
      ))
    }

@delegate:ResourceContentHash(-174_832_776)
public val Res.string.adjustment_deleted: StringResource by lazy {
      StringResource("string:adjustment_deleted", "adjustment_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18826, 74),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 26150, 98),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14629, 62),
      ))
    }

@delegate:ResourceContentHash(1_560_121_357)
public val Res.string.adjustment_description: StringResource by lazy {
      StringResource("string:adjustment_description", "adjustment_description", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18985, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 26389, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14768, 46),
      ))
    }

@delegate:ResourceContentHash(26_135_300)
public val Res.string.adjustment_description_hint: StringResource by lazy {
      StringResource("string:adjustment_description_hint", "adjustment_description_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 18901, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 26249, 139),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14692, 75),
      ))
    }

@delegate:ResourceContentHash(1_412_077_778)
public val Res.string.adjustment_edit_title: StringResource by lazy {
      StringResource("string:adjustment_edit_title", "adjustment_edit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19024, 69),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 26432, 105),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14815, 61),
      ))
    }

@delegate:ResourceContentHash(-2_097_695_992)
public val Res.string.adjustment_hint: StringResource by lazy {
      StringResource("string:adjustment_hint", "adjustment_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19094, 179),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 26538, 279),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14877, 163),
      ))
    }

@delegate:ResourceContentHash(1_943_998_651)
public val Res.string.adjustment_month_locked: StringResource by lazy {
      StringResource("string:adjustment_month_locked", "adjustment_month_locked", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19274, 139),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 26818, 195),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15041, 131),
      ))
    }

@delegate:ResourceContentHash(-1_499_092_863)
public val Res.string.adjustment_no_shift: StringResource by lazy {
      StringResource("string:adjustment_no_shift", "adjustment_no_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19414, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27014, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15173, 35),
      ))
    }

@delegate:ResourceContentHash(-320_098_693)
public val Res.string.adjustment_none: StringResource by lazy {
      StringResource("string:adjustment_none", "adjustment_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19450, 83),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27058, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15209, 71),
      ))
    }

@delegate:ResourceContentHash(-1_760_904_702)
public val Res.string.adjustment_saved: StringResource by lazy {
      StringResource("string:adjustment_saved", "adjustment_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19534, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27178, 100),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15281, 60),
      ))
    }

@delegate:ResourceContentHash(1_774_892_788)
public val Res.string.adjustment_shift: StringResource by lazy {
      StringResource("string:adjustment_shift", "adjustment_shift", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19603, 72),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27279, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15342, 56),
      ))
    }

@delegate:ResourceContentHash(867_893_484)
public val Res.string.adjustment_type: StringResource by lazy {
      StringResource("string:adjustment_type", "adjustment_type", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19815, 31),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27571, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15534, 31),
      ))
    }

@delegate:ResourceContentHash(1_087_323_403)
public val Res.string.adjustment_type_bonus: StringResource by lazy {
      StringResource("string:adjustment_type_bonus", "adjustment_type_bonus", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19676, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27384, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15399, 37),
      ))
    }

@delegate:ResourceContentHash(420_205_487)
public val Res.string.adjustment_type_deduction: StringResource by lazy {
      StringResource("string:adjustment_type_deduction", "adjustment_type_deduction", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19714, 49),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27430, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15437, 45),
      ))
    }

@delegate:ResourceContentHash(-532_359_071)
public val Res.string.adjustment_type_refund: StringResource by lazy {
      StringResource("string:adjustment_type_refund", "adjustment_type_refund", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19764, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27488, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15483, 50),
      ))
    }

@delegate:ResourceContentHash(-2_033_133_855)
public val Res.string.adjustments_title: StringResource by lazy {
      StringResource("string:adjustments_title", "adjustments_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19847, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27603, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15566, 57),
      ))
    }

@delegate:ResourceContentHash(-463_988_104)
public val Res.string.allocation_basis_equal: StringResource by lazy {
      StringResource("string:allocation_basis_equal", "allocation_basis_equal", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19901, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27677, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15624, 46),
      ))
    }

@delegate:ResourceContentHash(-2_082_435_109)
public val Res.string.allocation_basis_income: StringResource by lazy {
      StringResource("string:allocation_basis_income", "allocation_basis_income", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 19952, 59),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27740, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15671, 59),
      ))
    }

@delegate:ResourceContentHash(1_637_157_441)
public val Res.string.allocation_basis_labour_cost: StringResource by lazy {
      StringResource("string:allocation_basis_labour_cost", "allocation_basis_labour_cost", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20012, 68),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27812, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15731, 68),
      ))
    }

@delegate:ResourceContentHash(1_482_706_821)
public val Res.string.allocation_basis_net_sales: StringResource by lazy {
      StringResource("string:allocation_basis_net_sales", "allocation_basis_net_sales", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20081, 70),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 27921, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15800, 66),
      ))
    }

@delegate:ResourceContentHash(-125_626_673)
public val Res.string.allocation_method_fixed: StringResource by lazy {
      StringResource("string:allocation_method_fixed", "allocation_method_fixed", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20152, 47),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28016, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15867, 51),
      ))
    }

@delegate:ResourceContentHash(1_567_007_143)
public val Res.string.allocation_method_percentages: StringResource by lazy {
      StringResource("string:allocation_method_percentages", "allocation_method_percentages", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20200, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28084, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15919, 53),
      ))
    }

@delegate:ResourceContentHash(-1_843_189_115)
public val Res.string.allocation_method_proportional: StringResource by lazy {
      StringResource("string:allocation_method_proportional", "allocation_method_proportional", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20254, 58),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28146, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15973, 58),
      ))
    }

@delegate:ResourceContentHash(1_349_542_204)
public val Res.string.announcement_audience: StringResource by lazy {
      StringResource("string:announcement_audience", "announcement_audience", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20313, 33),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28217, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16032, 33),
      ))
    }

@delegate:ResourceContentHash(-1_542_387_988)
public val Res.string.announcement_compose_hint: StringResource by lazy {
      StringResource("string:announcement_compose_hint", "announcement_compose_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20347, 193),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28255, 309),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16066, 145),
      ))
    }

@delegate:ResourceContentHash(608_487_219)
public val Res.string.announcement_delete_text: StringResource by lazy {
      StringResource("string:announcement_delete_text", "announcement_delete_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20541, 116),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28565, 196),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16212, 108),
      ))
    }

@delegate:ResourceContentHash(-192_472_492)
public val Res.string.announcement_delete_title: StringResource by lazy {
      StringResource("string:announcement_delete_title", "announcement_delete_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20658, 65),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28762, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16321, 69),
      ))
    }

@delegate:ResourceContentHash(-1_065_639_808)
public val Res.string.announcement_deleted: StringResource by lazy {
      StringResource("string:announcement_deleted", "announcement_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20724, 56),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28856, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16391, 56),
      ))
    }

@delegate:ResourceContentHash(138_539_630)
public val Res.string.announcement_everyone: StringResource by lazy {
      StringResource("string:announcement_everyone", "announcement_everyone", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20781, 45),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28937, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16448, 41),
      ))
    }

@delegate:ResourceContentHash(-1_204_122_961)
public val Res.string.announcement_for_role: StringResource by lazy {
      StringResource("string:announcement_for_role", "announcement_for_role", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20827, 41),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 28979, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16490, 41),
      ))
    }

@delegate:ResourceContentHash(-1_649_836_678)
public val Res.string.announcement_former_author: StringResource by lazy {
      StringResource("string:announcement_former_author", "announcement_former_author", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20869, 66),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29025, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16532, 62),
      ))
    }

@delegate:ResourceContentHash(308_348_854)
public val Res.string.announcement_new: StringResource by lazy {
      StringResource("string:announcement_new", "announcement_new", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20936, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29116, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16595, 48),
      ))
    }

@delegate:ResourceContentHash(-2_068_204_352)
public val Res.string.announcement_pin: StringResource by lazy {
      StringResource("string:announcement_pin", "announcement_pin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21029, 48),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29237, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16680, 44),
      ))
    }

@delegate:ResourceContentHash(1_493_174_824)
public val Res.string.announcement_pinned: StringResource by lazy {
      StringResource("string:announcement_pinned", "announcement_pinned", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 20985, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29181, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16644, 35),
      ))
    }

@delegate:ResourceContentHash(-96_814_466)
public val Res.string.announcement_post: StringResource by lazy {
      StringResource("string:announcement_post", "announcement_post", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21170, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29434, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16805, 33),
      ))
    }

@delegate:ResourceContentHash(-260_119_947)
public val Res.string.announcement_posted: StringResource by lazy {
      StringResource("string:announcement_posted", "announcement_posted", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21078, 91),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29302, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16725, 79),
      ))
    }

@delegate:ResourceContentHash(1_925_266_688)
public val Res.string.announcement_read_by: StringResource by lazy {
      StringResource("string:announcement_read_by", "announcement_read_by", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21208, 64),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29492, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16839, 56),
      ))
    }

@delegate:ResourceContentHash(54_229_316)
public val Res.string.announcement_receipts_none: StringResource by lazy {
      StringResource("string:announcement_receipts_none", "announcement_receipts_none", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21273, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29565, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16896, 50),
      ))
    }

@delegate:ResourceContentHash(-1_056_652_036)
public val Res.string.announcement_receipts_not_yet: StringResource by lazy {
      StringResource("string:announcement_receipts_not_yet", "announcement_receipts_not_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21324, 53),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29620, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16947, 49),
      ))
    }

@delegate:ResourceContentHash(-230_836_928)
public val Res.string.announcement_receipts_privacy: StringResource by lazy {
      StringResource("string:announcement_receipts_privacy", "announcement_receipts_privacy", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21378, 109),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29670, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16997, 85),
      ))
    }

@delegate:ResourceContentHash(843_357_666)
public val Res.string.announcement_receipts_read: StringResource by lazy {
      StringResource("string:announcement_receipts_read", "announcement_receipts_read", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21488, 50),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29824, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17083, 42),
      ))
    }

@delegate:ResourceContentHash(521_086_934)
public val Res.string.announcement_receipts_title: StringResource by lazy {
      StringResource("string:announcement_receipts_title", "announcement_receipts_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21539, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29883, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17126, 51),
      ))
    }

@delegate:ResourceContentHash(-1_605_163_341)
public val Res.string.announcement_text: StringResource by lazy {
      StringResource("string:announcement_text", "announcement_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21595, 37),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29951, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17178, 37),
      ))
    }

@delegate:ResourceContentHash(-1_696_659_085)
public val Res.string.announcement_too_long: StringResource by lazy {
      StringResource("string:announcement_too_long", "announcement_too_long", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21633, 61),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 29993, 89),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17216, 57),
      ))
    }

@delegate:ResourceContentHash(1_808_235_730)
public val Res.string.announcement_unpin: StringResource by lazy {
      StringResource("string:announcement_unpin", "announcement_unpin", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21695, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30083, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17274, 34),
      ))
    }

@delegate:ResourceContentHash(-1_940_241_424)
public val Res.string.announcement_unread: StringResource by lazy {
      StringResource("string:announcement_unread", "announcement_unread", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21734, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30138, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17309, 31),
      ))
    }

@delegate:ResourceContentHash(-1_111_670_284)
public val Res.string.announcements_empty: StringResource by lazy {
      StringResource("string:announcements_empty", "announcements_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22063, 63),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30619, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17594, 55),
      ))
    }

@delegate:ResourceContentHash(-961_366_266)
public val Res.string.announcements_empty_manager: StringResource by lazy {
      StringResource("string:announcements_empty_manager", "announcements_empty_manager", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21770, 183),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30178, 279),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17341, 151),
      ))
    }

@delegate:ResourceContentHash(-642_492_966)
public val Res.string.announcements_empty_text: StringResource by lazy {
      StringResource("string:announcements_empty_text", "announcements_empty_text", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 21954, 108),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30458, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17493, 100),
      ))
    }

@delegate:ResourceContentHash(164_076_435)
public val Res.string.announcements_title: StringResource by lazy {
      StringResource("string:announcements_title", "announcements_title", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22127, 43),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30695, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17650, 47),
      ))
    }

@delegate:ResourceContentHash(-871_646_186)
public val Res.string.answers_filter_all: StringResource by lazy {
      StringResource("string:answers_filter_all", "answers_filter_all", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22171, 38),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30751, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17698, 38),
      ))
    }

@delegate:ResourceContentHash(-673_182_846)
public val Res.string.answers_group_available: StringResource by lazy {
      StringResource("string:answers_group_available", "answers_group_available", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22210, 55),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30786, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17737, 55),
      ))
    }

@delegate:ResourceContentHash(485_081_856)
public val Res.string.answers_group_empty: StringResource by lazy {
      StringResource("string:answers_group_empty", "answers_group_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("pl"), ), "${MD}values-pl/strings.commonMain.cvr", 22266, 35),
        ResourceItem(setOf(LanguageQualifier("uk"), ), "${MD}values-uk/strings.commonMain.cvr", 30850, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17793, 35),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("actual_work_action_description", Res.string.actual_work_action_description)
  map.put("actual_work_as_planned", Res.string.actual_work_as_planned)
  map.put("actual_work_end", Res.string.actual_work_end)
  map.put("actual_work_no_show", Res.string.actual_work_no_show)
  map.put("actual_work_no_show_reason", Res.string.actual_work_no_show_reason)
  map.put("actual_work_nobody", Res.string.actual_work_nobody)
  map.put("actual_work_person", Res.string.actual_work_person)
  map.put("actual_work_person_missing", Res.string.actual_work_person_missing)
  map.put("actual_work_reason", Res.string.actual_work_reason)
  map.put("actual_work_reason_hint", Res.string.actual_work_reason_hint)
  map.put("actual_work_record_absence", Res.string.actual_work_record_absence)
  map.put("actual_work_saved_absence", Res.string.actual_work_saved_absence)
  map.put("actual_work_saved_nobody", Res.string.actual_work_saved_nobody)
  map.put("actual_work_saved_planned", Res.string.actual_work_saved_planned)
  map.put("actual_work_section", Res.string.actual_work_section)
  map.put("actual_work_someone_else", Res.string.actual_work_someone_else)
  map.put("actual_work_start", Res.string.actual_work_start)
  map.put("actual_work_subtitle", Res.string.actual_work_subtitle)
  map.put("actual_work_subtitle_open", Res.string.actual_work_subtitle_open)
  map.put("actual_work_times", Res.string.actual_work_times)
  map.put("actual_work_times_from_clock", Res.string.actual_work_times_from_clock)
  map.put("actual_work_times_from_plan", Res.string.actual_work_times_from_plan)
  map.put("actual_work_times_missing", Res.string.actual_work_times_missing)
  map.put("actual_work_title", Res.string.actual_work_title)
  map.put("actual_work_worked_by", Res.string.actual_work_worked_by)
  map.put("add", Res.string.add)
  map.put("add_shift_add_another", Res.string.add_shift_add_another)
  map.put("add_shift_add_selected", Res.string.add_shift_add_selected)
  map.put("add_shift_assign", Res.string.add_shift_assign)
  map.put("add_shift_conflict_warning", Res.string.add_shift_conflict_warning)
  map.put("add_shift_custom", Res.string.add_shift_custom)
  map.put("add_shift_dialog_title", Res.string.add_shift_dialog_title)
  map.put("add_shift_duration", Res.string.add_shift_duration)
  map.put("add_shift_next_day", Res.string.add_shift_next_day)
  map.put("add_shift_nobody", Res.string.add_shift_nobody)
  map.put("add_shift_nothing", Res.string.add_shift_nothing)
  map.put("add_shift_pick_several", Res.string.add_shift_pick_several)
  map.put("add_shift_pick_time", Res.string.add_shift_pick_time)
  map.put("add_shift_unavailable_warning", Res.string.add_shift_unavailable_warning)
  map.put("add_to_calendar", Res.string.add_to_calendar)
  map.put("add_to_calendar_download", Res.string.add_to_calendar_download)
  map.put("add_to_calendar_hint", Res.string.add_to_calendar_hint)
  map.put("add_to_calendar_none", Res.string.add_to_calendar_none)
  map.put("add_to_calendar_saved", Res.string.add_to_calendar_saved)
  map.put("adjustment_add", Res.string.adjustment_add)
  map.put("adjustment_amount", Res.string.adjustment_amount)
  map.put("adjustment_day", Res.string.adjustment_day)
  map.put("adjustment_delete_confirm", Res.string.adjustment_delete_confirm)
  map.put("adjustment_deleted", Res.string.adjustment_deleted)
  map.put("adjustment_description", Res.string.adjustment_description)
  map.put("adjustment_description_hint", Res.string.adjustment_description_hint)
  map.put("adjustment_edit_title", Res.string.adjustment_edit_title)
  map.put("adjustment_hint", Res.string.adjustment_hint)
  map.put("adjustment_month_locked", Res.string.adjustment_month_locked)
  map.put("adjustment_no_shift", Res.string.adjustment_no_shift)
  map.put("adjustment_none", Res.string.adjustment_none)
  map.put("adjustment_saved", Res.string.adjustment_saved)
  map.put("adjustment_shift", Res.string.adjustment_shift)
  map.put("adjustment_type", Res.string.adjustment_type)
  map.put("adjustment_type_bonus", Res.string.adjustment_type_bonus)
  map.put("adjustment_type_deduction", Res.string.adjustment_type_deduction)
  map.put("adjustment_type_refund", Res.string.adjustment_type_refund)
  map.put("adjustments_title", Res.string.adjustments_title)
  map.put("allocation_basis_equal", Res.string.allocation_basis_equal)
  map.put("allocation_basis_income", Res.string.allocation_basis_income)
  map.put("allocation_basis_labour_cost", Res.string.allocation_basis_labour_cost)
  map.put("allocation_basis_net_sales", Res.string.allocation_basis_net_sales)
  map.put("allocation_method_fixed", Res.string.allocation_method_fixed)
  map.put("allocation_method_percentages", Res.string.allocation_method_percentages)
  map.put("allocation_method_proportional", Res.string.allocation_method_proportional)
  map.put("announcement_audience", Res.string.announcement_audience)
  map.put("announcement_compose_hint", Res.string.announcement_compose_hint)
  map.put("announcement_delete_text", Res.string.announcement_delete_text)
  map.put("announcement_delete_title", Res.string.announcement_delete_title)
  map.put("announcement_deleted", Res.string.announcement_deleted)
  map.put("announcement_everyone", Res.string.announcement_everyone)
  map.put("announcement_for_role", Res.string.announcement_for_role)
  map.put("announcement_former_author", Res.string.announcement_former_author)
  map.put("announcement_new", Res.string.announcement_new)
  map.put("announcement_pin", Res.string.announcement_pin)
  map.put("announcement_pinned", Res.string.announcement_pinned)
  map.put("announcement_post", Res.string.announcement_post)
  map.put("announcement_posted", Res.string.announcement_posted)
  map.put("announcement_read_by", Res.string.announcement_read_by)
  map.put("announcement_receipts_none", Res.string.announcement_receipts_none)
  map.put("announcement_receipts_not_yet", Res.string.announcement_receipts_not_yet)
  map.put("announcement_receipts_privacy", Res.string.announcement_receipts_privacy)
  map.put("announcement_receipts_read", Res.string.announcement_receipts_read)
  map.put("announcement_receipts_title", Res.string.announcement_receipts_title)
  map.put("announcement_text", Res.string.announcement_text)
  map.put("announcement_too_long", Res.string.announcement_too_long)
  map.put("announcement_unpin", Res.string.announcement_unpin)
  map.put("announcement_unread", Res.string.announcement_unread)
  map.put("announcements_empty", Res.string.announcements_empty)
  map.put("announcements_empty_manager", Res.string.announcements_empty_manager)
  map.put("announcements_empty_text", Res.string.announcements_empty_text)
  map.put("announcements_title", Res.string.announcements_title)
  map.put("answers_filter_all", Res.string.answers_filter_all)
  map.put("answers_group_available", Res.string.answers_group_available)
  map.put("answers_group_empty", Res.string.answers_group_empty)
}
